<template>
	<div>
		<div class="filter-toolbar">
			<span class="title">{{ $t('WEBAPP_PRESENTATIONTYPE') }}</span>
			<ResetButton :filterNames="['presentation_types']" />
		</div>
		<div class="jw-padding" style="display: flex; flex-flow: wrap">
			<ToggleButton
				v-for="option in PresentationTypes.filter(({ isQuality }) => isQuality)"
				:key="option.value"
				:active="isFilterActive('presentation_types', option.value)"
				:icon="'jw-check-icon'"
				@click.prevent="clicked(option.value)"
			>
				{{ option.label }}
			</ToggleButton>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { FilterCollection, FilterName } from '@/stores/useFilterStoreTypes';

import ToggleButton from '@/ui-components/ToggleButton.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { isFilterActive as filterActive } from '@/helpers/filter-helper';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { PresentationType } from '@/@types/graphql-types';

import { PresentationTypes } from '@/interfaces/titles';
import { CollectionType } from '../../enums/collection-type';

const props = defineProps<{
	collectionType: CollectionType;
	currentFilters: FilterCollection;
}>();

const router = useRouter();

const filterStore = useFilterStore();

function isFilterActive(filterName: FilterName, value: any) {
	return filterActive(filterName, value, filterStore.filters(props.collectionType));
}

async function clicked(presentationType: PresentationType) {
	const selectedState = isFilterActive('presentation_types', presentationType) ? 0 : 1;
	const newRoute = await filterStore.toggle({
		filterName: 'presentation_types',
		value: presentationType,
		selectedState,
	});

	if (newRoute) router.push(newRoute);
}
</script>
